export default "__VITE_ASSET__DfSHZnlA__"